import React, { useState } from "react";
import "./benefits.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import benefitsImage from "../../assets/BenefitsSection/benefits-image.svg";
export default function Benefits() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });
  const [activeCard, setActiveCard] = useState(0);
  const benefitsCards = [
    {
      heading: "Proactive AI Security & Risk Mitigation",
      paragraph:
        "Safeguard AI systems from emerging threats with real-time security intelligence.",
    },
    {
      heading: "Automated Compliance & Regulatory Alignment",
      paragraph:
        "Ensure AI security standards compliance with minimal manual intervention.",
    },
    {
      heading: "Enhanced Trust & AI Integrity",
      paragraph:
        "Build confidence in AI solutions with robust security frameworks and real-time monitoring.",
    },
    {
      heading: "Reduced AI Vulnerability Exposure",
      paragraph:
        "Strengthen AI applications by mitigating risks associated with adversarial attacks and data breaches.",
    },
    {
      heading: "Resilient AI Lifecycle Management",
      paragraph:
        "Maintain AI security from model training to deployment and beyond.",
    },
  ];

  return (
    <section
      className={`benefits-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="three"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Benefits</span>
          </div>

          <div className="heading-description">
            <h2>Strengthening AI Security for a Trusted Digital Future </h2>
            <p>
              Experience the transformative impact of AI security with robust
              risk mitigation, compliance assurance, and advanced threat
              monitoring.
            </p>
          </div>
        </div>
        <div className="benefits-content-wrapper row">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <div className="benefits-left">
              <img src={benefitsImage} alt="benefits" />
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <div className="benefits-right">
              {benefitsCards.map((item, index) => (
                <div className="benefits-card-wrapper" key={index}>
                  <div
                    className="benefit-card-button"
                    style={{ marginBottom: activeCard === index ? "2rem" : "" }}
                    onClick={() => setActiveCard(index)}
                  >
                    <h3>{item.heading}</h3>
                    <div
                      className={`toggle-button ${
                        activeCard === index ? "active" : ""
                      }`}
                    ></div>
                  </div>
                  <div
                    className={`benefit-card-content ${
                      activeCard === index ? "active" : ""
                    }`}
                  >
                    <p>{item.paragraph}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
